import React from 'react';
import { Link } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ErrorPageLayout from './ErrorPageLayout';

const NotFound: React.FC = () => {
  return (
    <ErrorPageLayout
      icon={<SearchOffIcon sx={{ fontSize: 44 }} />}
      color="info"
      code="404"
      title="ページが見つかりません"
    >
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
        お探しのページは存在しないか、移動した可能性があります。
        <br />
        URLをご確認ください。
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ mt: 1 }}>
        <Button
          variant="contained"
          component={Link}
          to="/"
          startIcon={<ArrowBackIcon />}
          sx={{
            px: 3,
            py: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          TOPへ戻る
        </Button>
      </Stack>
    </ErrorPageLayout>
  );
};

export default NotFound;
